module.exports = __webpack_public_path__ + "img/cropped-book-covertreasure-min.074971bf.jpg";